// extracted by mini-css-extract-plugin
export default {"container":"style_container__uDM4I","icon":"style_icon__DFM8A","textWrapper":"style_textWrapper__dP9ee","title":"style_title__q-7HI","value":"style_value__L20AX"};